import { Component } from '@angular/core';
import { LeaseDetailService } from "@modules/private/lease/data/services/view/lease-detail.service";
import { ApiLeaseService } from '../../data/services/api/api-lease.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-lease-asset-acquisition',
  templateUrl: './lease-asset-acquisition.component.html',
  styleUrls: ['./lease-asset-acquisition.component.scss'],
  providers: [MessageService]
})
export class LeaseAssetAcquisitionComponent {
  constructor(
    public leaseDetailService: LeaseDetailService,
    private apiLeaseService: ApiLeaseService,
    private messageService: MessageService
  ) { }

  get e() {
    return this.leaseDetailService.entityAcquisition
  }

  get data() {
    return this.leaseDetailService.data as any
  }

  /**
   * Manejar cuando se sube un archivo de asset acquisition
   */
  onFileSelected(fileUrl: string, documentType: string): void {
    // Actualizar el FormControl correspondiente si existe
    if (documentType === 'paymentProof') {
      // Si hay un FormControl específico para esto, actualizarlo
    }

    // Guardar con estructura unificada
    this.saveUnifiedAssetAcquisition(documentType, fileUrl);
  }

  /**
   * Manejar cuando se elimina un archivo de asset acquisition
   */
  onFileDeleted(documentType: string): void {
    // Guardar con estructura unificada
    this.saveUnifiedAssetAcquisition(documentType, null);
  }

  /**
   * Manejar descarga de archivos
   */
  onDownloadRequested(fileUrl: string, fileName: string): void {
    this.apiLeaseService.downloadDocumentByUrl(fileUrl).subscribe({
      next: (blob) => {
        if (!blob || blob.size === 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'El archivo descargado está vacío. Intente de nuevo.'
          });
          return;
        }

        const extension = fileUrl.includes('.') ? fileUrl.substring(fileUrl.lastIndexOf('.')) : '';
        const downloadName = fileName + (!fileName.includes('.') && extension ? extension : '');

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = downloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.messageService.add({
          severity: 'success',
          summary: 'Descarga',
          detail: 'Archivo descargado correctamente.'
        });
      },
      error: (error) => {
        console.error('Error al descargar archivo:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo descargar el archivo.'
        });
      }
    });
  }

  /**
   * Guardar datos unificados de asset acquisition
   */
  private saveUnifiedAssetAcquisition(changedField?: string, changedValue?: string | null): void {
    // Obtener datos actuales del formulario
    const formData = this.leaseDetailService.entityAcquisition.value;
    
    // Obtener datos actuales de archivos del lease
    const currentAssetAcquisition = this.data?.assetAcquisition || {};
    
    // Crear estructura unificada completa
    const unifiedAssetAcquisition = {
      assetAcquisition: {
        // Datos del formulario (fecha y proveedor)
        provider: formData.providerId || currentAssetAcquisition.provider || null,
        paymentDate: formData.paymentDate || currentAssetAcquisition.paymentDate || null,
        
        // Archivos existentes
        paymentProof: currentAssetAcquisition.paymentProof || null,
        invoicePdf: currentAssetAcquisition.invoicePdf || null,
        invoiceXml: currentAssetAcquisition.invoiceXml || null,
        circulationCard: currentAssetAcquisition.circulationCard || null,
        taxPayment: currentAssetAcquisition.taxPayment || null,
        
        // Aplicar cambio específico si se proporciona
        ...(changedField && { [changedField]: changedValue })
      }
    };

    this.apiLeaseService.putCollection(unifiedAssetAcquisition, undefined, 'leases/' + this.leaseDetailService.id)
      .subscribe((response) => {
        if (!response.error) {
          this.leaseDetailService.getLeaseDetail();
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Datos actualizados correctamente.'
          });
        }
      });
  }

  /**
   * Manejar cambios en el formulario (fecha y proveedor)
   */
  onFormFieldChange(): void {
    // Guardar cambios del formulario
    this.saveUnifiedAssetAcquisition();
  }
}
